import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import "../login/login.css";
import { LOGO } from "../../components/image";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleVerifyOtp = () => {
    navigate("/reset-password");
  };

  return (
    <>
      <div className="text-start ms-5 mt-5">
        <img src={LOGO} height={40} width={40} />
      </div>
      <div className="d-flex justify-content-center align-items-center full-height">
        <div className="login-box">
          <div className="text-start">Verify OTP</div>

          <div className="text-otp">Please Enter OTP You Received.</div>

          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={4}
            renderInput={(props) => (
              <input {...props} className="verify-input ms-4" placeholder="0" />
            )}
          />

          <button className="btn-form mt-5" onClick={handleVerifyOtp}>
            {/* {isLoader && (
                <div className="loader">
                  <Loader height={22} width={22} color="white" />
                </div>
              )} */}
            Reset Password
          </button>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
